"use client";

import {   Star, CheckCircle, ArrowRight,  } from 'lucide-react';
// import Image from 'next/image';
import { useState } from "react";

export default function RemoteStarter() {
  // const [currentSlide, setCurrentSlide] = useState(0);
  // const [isAutoPlaying, ] = useState(true);


  
  // Hero carousel data
  // const heroSlides = [
  //   {
  //     title: "Start Your Engine From Anywhere",
  //     subtitle: "Revolutionary remote starter technology that puts control at your fingertips",
  //     video: "/vdo2.mp4",
  //     // cta: "Explore Features"
  //   },
  //   {
  //     title: "Smart Climate Control",
  //     subtitle: "Pre-condition your vehicle's temperature before you even step outside",
  //     video: "/vdo1.mp4",
      
  //   },
    // {
    //   // title: "Advanced Security Features",
    //   // subtitle: "Military-grade encryption and multi-layer security for complete peace of mind",
    //  video: "/vdo2.mp4",
      
    // }
  // ];

  // Features data
  // const features = [
  //   {
  //     icon: <Smartphone className="w-8 h-8" />,
  //     title: "Mobile App Control",
  //     description: "Start, stop, and monitor your vehicle from anywhere with our intuitive mobile app. Compatible with iOS and Android."
  //   },
  //   {
  //     icon: <Shield className="w-8 h-8" />,
  //     title: "Advanced Security",
  //     description: "Bank-level encryption and multi-factor authentication ensure your vehicle stays secure at all times."
  //   },
  //   {
  //     icon: <Zap className="w-8 h-8" />,
  //     title: "Instant Response",
  //     description: "Lightning-fast response times with real-time status updates and confirmation notifications."
  //   },
  //   {
  //     icon: <Clock className="w-8 h-8" />,
  //     title: "Scheduled Start",
  //     description: "Set custom schedules to automatically start your vehicle at specific times and days."
  //   }
  // ];

  // Benefits data
  const benefits = [
    {
      title: "Save Time & Effort",
      description: "Start your motor from anywhere within a 2 km range — no need to walk to the pump set every time.",
      stat: "2 km Control Range"
    },
    {
      title: "Better Water Management",
      description: "Easily operate your motor on time, helping you save water and improve irrigation efficiency",
      stat: "Smart Irrigation Control"
    },
    {
      title: "Safe & Secure Operation",
      description: "Get full control over your motor without going to the field, even during bad weather or at night.",
      stat: "24/7 Safe Operation"
    },
    {
      title: "Longer Motor Life",
      description: "Operate your motor smoothly and safely, reducing the risk of damage from manual switching.",
      stat: "30% Longer Motor Life"
    }
  ];

  // Testimonials data
  const testimonials = [
    {
      name: "Gangadhar Armour",
      role: "Kadapa,AP",
      // company: "TechCorp",
      rating: 5,
      text: "“This remote starter has completely changed my farming routine. I can now switch my motor on or off from anywhere within 2 km. It’s simple, reliable, and saves me so much time every day!”",
      avatar: ""
    },
    {
      name: "Bathula Naresh",
      role: "Karimnagar,TG",
      // company: "InnovateLabs",
      rating: 4.5,
      text: "The security features are excellent. I can easily start or stop my motor from anywhere in my village. The installation was quick and hassle-free too.”",
      avatar: ""
    },
    {
      name: "SOMU Karnataka",
      role: "Karnataka",
      // company: "GlobalTech",
      rating: 5,
      text: "Best investment I’ve made for my farm. The timer feature lets me start the motor automatically at my chosen time — perfect for early morning irrigation. Highly recommend",
      avatar: ""
    }
  ];

  // Auto-play carousel
  // useEffect(() => {
  //   if (isAutoPlaying) {
  //     const interval = setInterval(() => {
  //       setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  //     }, 5000);
  //     return () => clearInterval(interval);
  //   }
  // }, [isAutoPlaying, heroSlides.length]);

  // const nextSlide = () => {
  //   setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  // };

  // const prevSlide = () => {
  //   setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  // };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Carousel Section */}
      <section className="">
        {/* <div className="absolute inset-0">
          {heroSlides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
                index === currentSlide 
                  ? 'opacity-100 scale-100' 
                  : 'opacity-0 scale-105'
              }`}
            >
              {slide.video ? (
                   <video
                    src={slide.video}
                    autoPlay
                    loop
                    muted
                    playsInline
                    // onError={(e) => console.error("Video error:", e)}
                    onLoadedData={() => console.log("Video loaded")}
                    className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto -translate-x-1/2 -translate-y-1/2 object-cover"
                  />
              ) : slide.video ? (
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{ backgroundImage: `url(${slide.video})` }}
                />
              ) : (
                <div className="absolute inset-0 z-10" />
              )}
              <div className="absolute inset-0 z-10" />
            </div>
          ))}
        </div> */}

        {/* Hero Content */}
                      {/* <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
                {heroSlides[currentSlide].title}
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-white max-w-2xl mx-auto">
                {heroSlides[currentSlide].subtitle}
              </p> */}
             
            

        {/* Carousel Controls */}
        
      </section>

      {/* Features Section */}
     {/* <section className="py-20 bg-gradient-to-b from-white to-green-50">
+        <div className="max-w-7xl mx-auto px-6 text-center">
+          <h1 className="text-4xl md:text-6xl font-bold text-[#6BAF92] mb-4">
+            Remote Starter — Comfort & Security, Anywhere
+          </h1>
+          <p className="text-lg text-[#4c4c4c] max-w-3xl mx-auto">
+            Control your vehicle from your phone. Quick install, bank-grade security, and scheduled starts.
+          </p>
+        </div>
+      </section> */}

      {/* Benefits Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#6BAF92] mb-6">
              Why Choose Remote Starter?
            </h2>
            <p className="text-xl text-[#4c4c4c] max-w-3xl mx-auto">
              Discover the compelling benefits that make our remote starter the smart choice for modern Agriculture.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="flex items-start space-x-6 group"
              >
                <div className="flex-shrink-0">
                  <CheckCircle className="w-8 h-8 text-green-400 group-hover:text-green-200 transition-colors duration-300" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-[#6BAF92] mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-[#4c4c4c] mb-4 leading-relaxed">
                    {benefit.description}
                  </p>
                  <div className="inline-block bg-[#6BAF92] text-white px-4 py-2 rounded-full text-sm font-semibold">
                    {benefit.stat}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#6BAF92] mb-6">
              What Our Customers Say
            </h2>
            <p className="text-xl text-[#4c4c4c] max-w-3xl mx-auto">
              Join thousands of satisfied customers who have transformed their daily driving experience.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard key={index} testimonial={testimonial} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-[#6BAF92] mb-6">
            Ready to Go With Remote Starter?
          </h2>
          <p className="text-xl text-[#4c4c4c] mb-8">
            Join thousands of drivers who have already upgraded to the future of vehicle control.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="px-8 py-4 bg-[#6BAF92]  hover:bg-[#5EA785] text-white text-sm font-medium rounded-full shadow-md transition-all duration-300 hover:shadow-lg hover:scale-105 cursor-pointer">
              <a href="/Order"> 
              Order Now
              <ArrowRight className="inline-block ml-2 w-5 h-5" />
              </a>
            </button>
            <button className="px-8 py-4 bg-[#6BAF92]  hover:bg-[#5EA785] text-white text-sm font-medium rounded-full shadow-md transition-all duration-300 hover:shadow-lg hover:scale-105 cursor-pointer">
              <a href="/ContactUs">
              Contact Us
              </a>
            </button>
          </div>
        </div>
      </section>

      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 3s ease-out;
        }
      `}</style>
    </div>
  );
}

interface Testimonial {
  name: string;
  role?: string;
  company?: string;
  rating: number;
  text: string;
  avatar?: string;
}

function TestimonialCard({ testimonial }: { testimonial: Testimonial }) {
  const [src, setSrc] = useState<string | undefined>(testimonial.avatar);

  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-500 hover:scale-105 cursor-pointer shadow-[#6BAF92]">
      <div className="flex items-center mb-6">
        <img
          src={src}
          height={100}
          width={100}
          alt={testimonial.name}
          className="w-12 h-12 rounded-full object-cover mr-4"
          onError={() => setSrc(undefined)}
        />
        <div>
          <h4 className="text-[#6BAF92] font-bold">{testimonial.name}</h4>
          <p className="text-[#4c4c4c] text-sm">
            {[testimonial.role, testimonial.company].filter(Boolean).join(' at ')}
          </p>
        </div>
      </div>

      <div className="flex mb-4">
        {[...Array(Math.floor(testimonial.rating))].map((_, i) => (
          <Star key={i} className="w-5 h-5 text-yellow-400" />
        ))}
      </div>

      <p className="text-[#4c4c4c] leading-relaxed italic">
        {testimonial.text}
      </p>
    </div>
  );
}